module.exports = __webpack_public_path__ + "img/result_txt_h.96d862c2.png";